"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config = {
    rounding: { type: '', digits: 1, minFractionDigits: 0 },
};
exports.default = config;
//# sourceMappingURL=libConfig.js.map